angular.module('trainerWebApp.resources').factory('checkDnsResource', ['$resource', '$location', 'errorHandler',
  function($resource, $location, errorHandler) {

    var CheckDnsResource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/checkDns');

    CheckDnsResource.prototype.send = function send(domainName, resultCb, errorCb) {
      return CheckDnsResource.save({}, {domainName:domainName}, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new CheckDnsResource;
  }
]);
